<template>
	<div :class="[size === 'md' ? 'wide-panel' : 'panel', isMobile && 'panel-mobile']" id="panelView" @click="cancelEvent" @dblclick="cancelEvent">
		<template v-if="panelLoading">
			<v-sheet class="loading-sheet" min-height="100%" max-height="100%" min-width="100%" max-width="100%" color="#160d2e">
				<SpinLoader :panelLoading="true" />
			</v-sheet>
		</template>

		<template>
			<!-- Panel Header -->
			<Header />

			<!-- Panel Tabs -->
			<Tabs :activeTab="activeTab" @changeTab="setActiveTab" />

			<!-- Tab Items -->
			<div class="tabs-items">
				<div :class="bitsCreditAmount > 0 && 'credit-bits'">
					<template v-if="activeTab === 1">
						<StickersTab />
					</template>

					<template v-if="activeTab === 2">
						<LeaderboardTab />
					</template>
				</div>
			</div>

			<!-- Error Dialog -->
			<ErrorDialog :errorDialog="errorDialog" @close="errorDialog = false" />
		</template>
	</div>
</template>

<script>
import { ref, computed } from 'vue';
import { useStore } from '@/store';
import Header from '@/components/panel/Header.vue';
import Tabs from '@/components/panel/Tabs.vue';
import StickersTab from '@/components/panel/StickersTab.vue';
import LeaderboardTab from '@/components/panel/LeaderboardTab.vue';
import ErrorDialog from './ErrorDialog.vue';
import SpinLoader from '@/components/panel/SpinLoader';

export default {
	components: {
		SpinLoader,
		Header,
		Tabs,
		StickersTab,
		LeaderboardTab,
		ErrorDialog,
	},
	props: {
		theme: {
			type: String,
			default: 'violet',
		},
		size: {
			type: String,
			default: 'sm',
		},
	},
	setup() {
		const store = useStore();
		const isMobile = computed(() => {
			return store.state.isMobile;
		});

		const panelLoading = computed(() => {
			return store.state.panelLoading;
		});

		const activeTab = ref(1);
		const errorDialog = ref(false);

		const setActiveTab = tab => {
			activeTab.value = tab;
		};

		const cancelEvent = (event) => {
			event.stopImmediatePropagation();
		};

		const bitsCreditAmount = computed(() => {
			return store.state.bitsCreditAmount;
		});

		return {
			panelLoading,
			isMobile,
			activeTab,
			errorDialog,
			setActiveTab,
			bitsCreditAmount,
			cancelEvent
		};
	},
};
</script>
